import React from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  input {
    height: 36px;
    border-radius: 5px;
    ${(props) => (props.error ? "border: 1px solid red" : "")};
  }

  label {
    color: ${(props) => (props.error ? "red" : "")};
  }
`;

const Input = ({
  name,
  value = "",
  label,
  onChange,
  error,
  type = "text",
  search,
  onClick,
  placeholder = "",
  onKeyPress,
  onKeyDown,
  maxLength = 500,
  disabled = false,
  checked,
  validate = false,
  classname = "btn btn-primary",
}) => {


  return (
    <div className="row">
      <InputWrapper error={error}>
        {label && <label htmlFor={name}>{label} </label>}

        <div className="input-group">
          <input
            value={value}
            onChange={(e) => onChange(name, e.target.value, validate)}
            id={name}
            name={name}
            type={type}
            disabled={disabled}
            checked={checked}
            maxLength={maxLength}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
            className="form-control"
          ></input>
          {search && (
            <button
              type="button"
              className={classname}
              disabled={disabled}
              onClick={() => onClick(name)}
            >
              {search}
            </button>
          )}
        </div>
      </InputWrapper>

      {/* {error && <div className="alert alert-danger">{error}</div>} */}
    </div>
  );
};

export default Input;